import React, { useState, useEffect } from "react";
import { Amplify } from "aws-amplify";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { getCurrentUser } from "aws-amplify/auth";
import awsconfig from "./aws-exports";
import Home from "./components/js/Home";
import SignIn from "./components/js/SignIn";
import SignUp from "./components/js/SignUp";
import Dashboard from "./components/js/Dashboard";
import Support from "./components/js/Support";
import Privacy from "./components/js/Privacy";
import Terms from "./components/js/Terms";
import About from "./components/js/About";
import ForgotPassword from "./components/js/ForgotPassword";
import './App.css';

Amplify.configure(awsconfig);

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const checkAuth = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
      setIsAuthenticated(true);
    } catch (err) {
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  if (isLoading) {
    return (
      <div className="App">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/support" element={<Support />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route 
          path="/dashboard" 
          element={
            isAuthenticated ? (
              <Dashboard user={user} onAuthStateChange={checkAuth} />
            ) : (
              <Navigate to="/signin" replace />
            )
          } 
        />
        <Route 
          path="/signin" 
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <SignIn onSignInSuccess={checkAuth} />
            )
          }
        />
        <Route 
          path="/signup" 
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <SignUp />
            )
          }
        />
        <Route 
          path="/forgot-password" 
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <ForgotPassword />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;